import { columns } from './properties/columns'
import { filter } from './properties/filter'
import { sort } from './../properties/sort'
import { pagination } from './../properties/pagination'
import { model } from "./properties/model";
import { rules } from "./properties/rules";

export const state = {
    list: [],
    laboratory: [],
    color: [],
    relation_list: [],
    relation_free_list: [],
    relation_list_order: [],
    inventory: [],
    inventory_service_name: [],
    parent_inventory: [],
    relationInventory: [],
    selected_list: [],
    selected_relation_list: [],
    model: JSON.parse(JSON.stringify(model)),
    columns: columns,
    filter: filter,
    pagination: JSON.parse(JSON.stringify(pagination)),
    sort: JSON.parse(JSON.stringify(sort)),
    rules: rules,
    is_residence: true,
};
